"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_spring_1 = require("react-spring");
var react_use_gesture_1 = require("react-use-gesture");
var Arrow_1 = __importDefault(require("./components/Arrow"));
var Bullet_1 = __importDefault(require("./components/Bullet"));
var Slide_1 = __importDefault(require("./components/Slide"));
var Caption_1 = __importDefault(require("./components/Caption"));
var styles_1 = require("./styles");
function Carousel(_a) {
    var _b = _a.activeIndex, activeIndex = _b === void 0 ? 0 : _b, arrow = _a.arrow, _c = _a.autoplay, autoplay = _c === void 0 ? 0 : _c, bullet = _a.bullet, children = _a.children, _d = _a.withArrows, withArrows = _d === void 0 ? false : _d, _e = _a.withBullets, withBullets = _e === void 0 ? false : _e, _f = _a.onSlideChange, onSlideChange = _f === void 0 ? function () { return undefined; } : _f, _g = _a.setSlideCustom, setSlideCustom = _g === void 0 ? undefined : _g, _h = _a.slidesAtOnce, slidesAtOnce = _h === void 0 ? 1 : _h, style = _a.style;
    var slides = react_1.default.Children.map(children, function (child) {
        if (child.type !== Slide_1.default)
            return;
        return child;
    });
    var sliderRef = react_1.useRef(null);
    var _j = react_1.useState(0), slide = _j[0], setSlideOriginal = _j[1];
    var _k = react_1.useState(false), isDragging = _k[0], setDragging = _k[1];
    var setSlide = setSlideCustom
        ? function (index) { return setSlideOriginal(setSlideCustom(index)); }
        : setSlideOriginal;
    var _l = react_spring_1.useSprings(slides.length, function (index) { return ({
        offset: index,
    }); }), springProps = _l[0], setSpringProps = _l[1];
    var gesture = react_use_gesture_1.useGesture({
        onDrag: function (_a) {
            var down = _a.down, xDelta = _a.movement[0], xDir = _a.direction[0], distance = _a.distance, cancel = _a.cancel, first = _a.first, active = _a.active;
            if (first)
                setDragging(true);
            if (sliderRef && sliderRef.current && sliderRef.current.parentElement) {
                var width_1 = sliderRef.current.parentElement.getBoundingClientRect().width;
                if (down && distance > width_1 / 2) {
                    cancel && cancel();
                    if (active)
                        setSlide(Math.min(Math.max(slide + (xDir > 0 ? -1 : 1), 0), slides.length - slidesAtOnce));
                }
                // see:  https://github.com/react-spring/react-spring/issues/861
                // @ts-ignore
                setSpringProps(function (index) { return ({
                    offset: (active && down ? xDelta : 0) / width_1 + (index - slide),
                }); });
            }
        },
        onClick: function () {
            if (isDragging)
                return setDragging(false);
            handleSlideClick(slide);
        },
    }, {
        drag: {
            delay: 200,
        },
    });
    react_1.useEffect(function () {
        // see:  https://github.com/react-spring/react-spring/issues/861
        // @ts-ignore
        setSpringProps(function (index) { return ({ offset: index - slide }); });
        onSlideChange(slide);
    }, [slide, setSpringProps, onSlideChange]);
    react_1.useEffect(function () {
        var interval;
        if (autoplay > 0) {
            interval = global.setInterval(function () {
                var targetIndex = (slide + 1) % slides.length;
                setSlide(targetIndex);
            }, autoplay);
        }
        return function () {
            if (interval)
                clearInterval(interval);
        };
    }, [autoplay, slides.length, slide]);
    react_1.useEffect(function () {
        setSlide(activeIndex % slides.length);
    }, [activeIndex, slides.length]);
    function handleSlideClick(slideIndex) {
        slides[slideIndex].props.onClick && slides[slideIndex].props.onClick();
    }
    function goToNextSlide() {
        if (slide === slides.length - slidesAtOnce)
            return setSlide(0);
        setSlide(slide + 1);
    }
    function goToPrevSlide() {
        if (slide === 0)
            return setSlide(slides.length - slidesAtOnce);
        setSlide(slide - 1);
    }
    function renderBullets() {
        var arr = [];
        for (var index = 0; index <= slides.length - slidesAtOnce; index++) {
            arr.push(react_1.default.createElement(Bullet_1.default, { key: index, index: index, bullet: bullet, setSlide: setSlide, activeIndex: slide, style: style && style.bullet }));
        }
        return arr;
    }
    var isMultiSlide = slides.length > 1;
    return (react_1.default.createElement(styles_1.MainContainer, { ref: sliderRef, style: style && style.root },
        react_1.default.createElement(styles_1.Container, null,
            isMultiSlide && withArrows && (react_1.default.createElement(styles_1.ArrowsContainer, null,
                react_1.default.createElement(Arrow_1.default, { arrow: arrow, style: style && style.arrow, direction: "left", onClick: goToPrevSlide }),
                react_1.default.createElement(Arrow_1.default, { arrow: arrow, style: style && style.arrow, direction: "right", onClick: goToNextSlide }))),
            isMultiSlide && withBullets && (react_1.default.createElement(styles_1.BulletsContainer, null,
                react_1.default.createElement(styles_1.BulletList, null, renderBullets()))),
            springProps.map(function (_a, index) {
                var offset = _a.offset;
                return (react_1.default.createElement(react_spring_1.animated.div, __assign({}, gesture(), { key: index, style: {
                        transform: offset.interpolate(function (offsetX) { return "translate3d(" + offsetX * 100 + "%, 0, 0)"; }),
                        position: "absolute",
                        width: 100 / slidesAtOnce + "%",
                        height: "100%",
                        willChange: "transform",
                    } }), slides[index]));
            }))));
}
Carousel.Slide = Slide_1.default;
Carousel.Caption = Caption_1.default;
exports.default = Carousel;
//# sourceMappingURL=index.js.map